/* GARDEN EQUIPMENT — Recherche IA (reproduction SmartSearch.tsx) */
(function () {
  "use strict";

  var overlay = document.querySelector("[data-ge-search]");
  if (!overlay) return;
  var input = overlay.querySelector("[data-ge-search-input]");
  var results = overlay.querySelector("[data-ge-search-results]");
  var endpoint = (window.GE_AI && window.GE_AI.endpoint) || "";
  var timer = null;
  var controller = null;

  function isPro() { return document.documentElement.classList.contains("ge-is-b2b"); }

  function open() {
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    setTimeout(function () { input && input.focus(); }, 50);
  }
  function close() {
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function esc(s) { return (s || "").replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  function hint() {
    results.innerHTML = '<p class="ge-search__hint">Tapez votre besoin : « abri pour Husqvarna 305 », « lames Worx », « lève-tondeuse 500 kg »…</p>';
  }
  function loading() {
    results.innerHTML = '<div class="ge-search__loading"><span class="ge-search__spin"></span> Recherche en cours…</div>';
  }

  function render(data) {
    var products = (data && data.products) || [];
    var msg = (data && data.message) || "";
    if (!products.length) {
      results.innerHTML = '<p class="ge-search__hint">' + esc(msg || "Aucun produit trouvé. Essayez d'autres mots-clés.") + "</p>";
      return;
    }
    var cards = products.map(function (p) {
      var img = p.image ? '<div class="ge-search__card-img"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"></div>' : '<div class="ge-search__card-img"></div>';
      return '<a class="ge-search__card" href="/products/' + esc(p.handle) + '">' + img +
        '<div class="ge-search__card-b"><p class="ge-search__card-t">' + esc(p.title) + '</p><p class="ge-search__card-p">' + esc(p.price) + "</p></div></a>";
    }).join("");
    results.innerHTML = (msg ? '<p class="ge-search__msg">' + esc(msg) + "</p>" : "") + '<div class="ge-search__grid">' + cards + "</div>";
  }

  function run(q) {
    q = (q || "").trim();
    if (q.length < 2) { hint(); return; }

    // Pas de fonction IA configurée → recherche Shopify native
    if (!endpoint) { window.location.href = "/search?q=" + encodeURIComponent(q); return; }

    loading();
    if (controller) controller.abort();
    controller = new AbortController();
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: q, isPro: isPro(), locale: (document.documentElement.lang || "fr").slice(0, 2) }),
      signal: controller.signal,
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function (e) { if (e.name !== "AbortError") { window.location.href = "/search?q=" + encodeURIComponent(q); } });
  }

  /* Débounce à la frappe */
  if (input) {
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value;
      if (q.trim().length < 2) { hint(); return; }
      timer = setTimeout(function () { run(q); }, 450);
    });
  }

  overlay.addEventListener("submit", function (e) { e.preventDefault(); clearTimeout(timer); run(input.value); });

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-ge-search-open]")) { e.preventDefault(); open(); return; }
    if (e.target.closest("[data-ge-search-close]")) { e.preventDefault(); close(); return; }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) close();
  });
})();
